// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1766":"b39dbd97004bc4b5","1930":"b39dbd97004bc4b5","2888":"bf0da975b43132f2"}[chunkId] + ".css";
};